export enum ScanPositionType {
  Front = "front",
  RightSide = "right-side",
  LeftSide = "left-side",
}

export interface PhotoScanSlide {
  id: ScanPositionType;
  step: PhotoScanStep;
  image: string | null;
  file: File | null;
  placeholder: string;
  title: string;
  preDescription: string;
  postDescription: string;
}

export enum PhotoScanStep {
  GET_STARTED = "get-started",
  START_CAPTURE = "start-capture",
  FRONT_SCAN = "front-scan",
  RIGHT_SIDE_SCAN = "right-side-scan",
  LEFT_SIDE_SCAN = "left-side-scan",
  READY_TO_SUBMIT = "ready-to-submit",
  REPORT_GENERATING = "report-generating",
  REPORT_GENERATED = "report-generated",
}

export const PHOTO_SCAN_FIRST_SLIDE = PhotoScanStep.FRONT_SCAN;
export const PHOTO_SCAN_LAST_SLIDE = PhotoScanStep.LEFT_SIDE_SCAN;
export const PhotoScanSlides = [
  PhotoScanStep.FRONT_SCAN,
  PhotoScanStep.RIGHT_SIDE_SCAN,
  PhotoScanStep.LEFT_SIDE_SCAN,
];

export const PhotoScanStepValues = [
  PhotoScanStep.GET_STARTED,
  PhotoScanStep.START_CAPTURE,
  PhotoScanStep.FRONT_SCAN,
  PhotoScanStep.RIGHT_SIDE_SCAN,
  PhotoScanStep.LEFT_SIDE_SCAN,
  PhotoScanStep.READY_TO_SUBMIT,
  PhotoScanStep.REPORT_GENERATING,
  PhotoScanStep.REPORT_GENERATED,
];

export const getNextPhotoScanStep = (
  currentStep: PhotoScanStep
): PhotoScanStep => {
  const currentStepIndex = PhotoScanStepValues.indexOf(currentStep);
  return PhotoScanStepValues[currentStepIndex + 1];
};

export const getPrevPhotoScanStep = (
  currentStep: PhotoScanStep
): PhotoScanStep => {
  const currentStepIndex = PhotoScanStepValues.indexOf(currentStep);
  return PhotoScanStepValues[currentStepIndex - 1];
};
